"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseFulfillDTO = exports.PurchaseCompleteDTO = exports.PurchaseAttemptDTO = void 0;
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const dto_factory_1 = require("../types/dto-factory");
let PurchaseAttemptDTO = class PurchaseAttemptDTO extends (0, dto_factory_1.DTOFactory)() {
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Unique transaction identifier'),
    (0, decorators_1.Warning)('Use only if known prior'),
    __metadata("design:type", String)
], PurchaseAttemptDTO.prototype, "transactionId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Total value'),
    (0, decorators_1.Warning)('Typically quantity * unitPrice'),
    __metadata("design:type", Number)
], PurchaseAttemptDTO.prototype, "total", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Purchase currency type'),
    __metadata("design:type", String)
], PurchaseAttemptDTO.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Unique product id'),
    __metadata("design:type", String)
], PurchaseAttemptDTO.prototype, "productId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Quantity purchased'),
    __metadata("design:type", Number)
], PurchaseAttemptDTO.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Price Ea.'),
    __metadata("design:type", Number)
], PurchaseAttemptDTO.prototype, "unitPrice", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Transaction fee'),
    __metadata("design:type", String)
], PurchaseAttemptDTO.prototype, "transactionFee", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Total USD value of this transaction'),
    (0, decorators_1.Warning)('Only set if concrete'),
    __metadata("design:type", String)
], PurchaseAttemptDTO.prototype, "totalUSDValue", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Currency value in USD at time of event'),
    (0, decorators_1.Warning)('Only set if concrete'),
    __metadata("design:type", String)
], PurchaseAttemptDTO.prototype, "currencyUSDValue", void 0);
PurchaseAttemptDTO = __decorate([
    (0, decorators_1.Describe)('A purchase was initiated which is asyncronous in nature')
], PurchaseAttemptDTO);
exports.PurchaseAttemptDTO = PurchaseAttemptDTO;
let PurchaseCompleteDTO = class PurchaseCompleteDTO extends (0, dto_factory_1.DTOFactory)() {
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Unique lookup id for transaction, e.g. Payment Hash'),
    __metadata("design:type", String)
], PurchaseCompleteDTO.prototype, "transactionId", void 0);
PurchaseCompleteDTO = __decorate([
    (0, decorators_1.Describe)('A purchase has completed validation and is awaiting fulfillment')
], PurchaseCompleteDTO);
exports.PurchaseCompleteDTO = PurchaseCompleteDTO;
let PurchaseFulfillDTO = class PurchaseFulfillDTO extends (0, dto_factory_1.DTOFactory)() {
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Unique transaction identifier'),
    (0, decorators_1.Warning)('Should match PurchaseAttemptDTO event'),
    __metadata("design:type", String)
], PurchaseFulfillDTO.prototype, "transactionId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Total value'),
    (0, decorators_1.Warning)('Typically quantity * unitPrice'),
    __metadata("design:type", Number)
], PurchaseFulfillDTO.prototype, "total", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Purchase currency type'),
    __metadata("design:type", String)
], PurchaseFulfillDTO.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Unique product id'),
    __metadata("design:type", String)
], PurchaseFulfillDTO.prototype, "productId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Quantity purchased'),
    __metadata("design:type", Number)
], PurchaseFulfillDTO.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Price Ea.'),
    __metadata("design:type", Number)
], PurchaseFulfillDTO.prototype, "unitPrice", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Transaction fee'),
    __metadata("design:type", String)
], PurchaseFulfillDTO.prototype, "transactionFee", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Total USD value of this transaction'),
    (0, decorators_1.Warning)('Only set if concrete'),
    __metadata("design:type", String)
], PurchaseFulfillDTO.prototype, "totalUSDValue", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Currency value in USD at time of event'),
    (0, decorators_1.Warning)('Only set if concrete'),
    __metadata("design:type", String)
], PurchaseFulfillDTO.prototype, "currencyUSDValue", void 0);
PurchaseFulfillDTO = __decorate([
    (0, decorators_1.Describe)('A purchase was fulfilled completely'),
    (0, decorators_1.Warning)('TransactionID should match purchase attempt, if applicable')
], PurchaseFulfillDTO);
exports.PurchaseFulfillDTO = PurchaseFulfillDTO;
